// 接口主机配置（绝对路径）
// 开发环境: http://localhost:3009
// 生产环境: https://www.ya-lan.com
const DEV_HOST = 'http://localhost:3009';
const PROD_HOST = 'https://www.ya-lan.com';

export const API_HOST =  PROD_HOST ;
// export const API_HOST =  DEV_HOST ;